var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        title: _vm.isDuplicates
          ? "Convert / Replace or upload as new file:"
          : "Convert:",
        centered: "",
      },
      on: { hide: _vm.closeHandler },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "ButtonOutline",
                {
                  attrs: { variant: "outline-primary" },
                  on: { click: _vm.handleHide },
                },
                [_vm._v("\n      Cancel\n    ")]
              ),
              _vm._v(" "),
              _vm.selected === 3
                ? _c(
                    "ButtonPrimary",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.handleHide },
                    },
                    [_vm._v("\n      Ok\n    ")]
                  )
                : _c(
                    "ButtonPrimary",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.handleClick },
                    },
                    [_vm._v("\n      Upload\n    ")]
                  ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.isDuplicates
        ? _c("p", { staticClass: "mt-2" }, [
            _vm._v(
              "\n    One or more items already exists in this location. \n    Do you want to replace the existing items with a new version or keep both items?\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isDuplicates
        ? _c(
            "ul",
            { staticClass: "text-break" },
            _vm._l(_vm.payload.files, function (file) {
              return _c("li", { key: file.id }, [
                _vm._v("\n      " + _vm._s(file?.name) + "\n    "),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isDuplicates
        ? _c(
            "b-form-group",
            [
              _c(
                "b-form-radio",
                {
                  attrs: { value: 1 },
                  model: {
                    value: _vm.selected,
                    callback: function ($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected",
                  },
                },
                [_vm._v("\n      Replace existing items\n    ")]
              ),
              _vm._v(" "),
              _c(
                "b-form-radio",
                {
                  attrs: { value: 2 },
                  model: {
                    value: _vm.selected,
                    callback: function ($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected",
                  },
                },
                [_vm._v("\n      Keep all items\n    ")]
              ),
              _vm._v(" "),
              _c(
                "b-form-radio",
                {
                  attrs: { value: 3 },
                  model: {
                    value: _vm.selected,
                    callback: function ($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected",
                  },
                },
                [_vm._v("\n      Stop\n    ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form-checkbox",
        {
          attrs: { value: true, "unchecked-value": false },
          model: {
            value: _vm.isRemoveBackground,
            callback: function ($$v) {
              _vm.isRemoveBackground = $$v
            },
            expression: "isRemoveBackground",
          },
        },
        [_vm._v("\n    Remove background\n  ")]
      ),
      _vm._v(" "),
      _c(
        "b-form-checkbox",
        {
          attrs: { value: true, "unchecked-value": false },
          model: {
            value: _vm.isCropToImage,
            callback: function ($$v) {
              _vm.isCropToImage = $$v
            },
            expression: "isCropToImage",
          },
        },
        [_vm._v("\n    Crop to image\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }